import HeartLoader from './HeartLoader';

export default HeartLoader;
